<template>
  <v-card>
    <v-card-title>Selecione um posto para entrar</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 300px;">
      <v-list>
        <template v-for="item in postos">
          <v-list-tile :key="item.cnpj" :value="item" @click="selecionarPosto(item)" ripple>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.nome_fantasia">
              </v-list-tile-title>
              <v-list-tile-sub-title v-html="`CNPJ: ${item.cnpj}`">
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-avatar>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar v-on="on">
                    <v-icon v-if="item.ativo" color="green">done_all</v-icon>
                    <v-icon v-else color="red">close</v-icon>
                  </v-avatar>
                </template>
                <span v-if="item.ativo">Ativo</span>
                <span v-else>Inativo</span>
              </v-tooltip>
            </v-list-tile-avatar>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" flat @click="cadastrarPosto()">Cadastrar novo posto</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-dialog
      lazy
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      v-model="cadastroPosto"
      width="500"
    >
      <cad-posto
        v-if="cadastroPosto"
        @fechar="cadastroPosto = false"
        @success="$emit('success')"
        @error="$emit('error')"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import CadPosto from '@/components/cadastros/CadNovoPosto'

export default {
  components: { CadPosto },
  data () {
    return {
      posto: null,
      cadastroPosto: false
    }
  },
  watch: {
    headers (val) {
      if (val !== null && val !== undefined) {
        this.listarPostos()
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    postos () {
      return this.$store.getters.postos
    }
  },
  mounted () {
    if (this.headers) {
      this.listarPostos()
    }
  },
  methods: {
    fecharPosto () {
      this.cadastroPosto = false
    },
    selecionarPosto (posto) {
      this.$emit('postoSelected', posto)
      this.posto = null
    },
    listarPostos () {
      this.$store.dispatch('meusPostos')
    },
    cadastrarPosto () {
      this.cadastroPosto = true
    }
  }
}
</script>
